export default __webpack_public_path__ + "static/media/Pop.a5fe9ce9.svg";